export default function getWordcountColor(bodyWords, minWordcount, targetWordcount, maxWordcount) {
  if (targetWordcount <= 0) return '$textBrand';
  if (bodyWords > maxWordcount) return '$error600';
  if (bodyWords > targetWordcount) return '$amber600';
  if (bodyWords > minWordcount) return '$green600';
  return '$textBrand';
}
